import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_RFID_GROUP = createActionTypes('FETCH_RFID_GROUP');
export const GET_RFID_GROUP = createActionTypes('GET_RFID_GROUP');
export const CREATE_RFID_GROUP = createActionTypes('CREATE_RFID_GROUP');
export const UPDATE_RFID_GROUP = createActionTypes('UPDATE_RFID_GROUP');
export const DELETE_RFID_GROUP = createActionTypes('DELETE_RFID_GROUP');
